import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function DojoSSOPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Anmeldung läuft…');
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('dojo_token');
    if (!token) {
      setError('Kein SSO-Token vorhanden.');
      return;
    }

    axios.post('/api/auth/dojo-sso', { token })
      .then(res => {
        if (res.data?.success && res.data.token) {
          localStorage.setItem('token', res.data.token);
          setStatus('Erfolgreich! Weiterleitung…');
          setTimeout(() => navigate('/dashboard'), 800);
        } else {
          setError('SSO fehlgeschlagen.');
        }
      })
      .catch(err => {
        setError(err.response?.data?.error || 'Verbindungsfehler');
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps -- der Tausch des SSO-Tokens darf genau einmal laufen
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0d0f1a', color: '#fff', fontFamily: 'sans-serif', flexDirection: 'column', gap: '1rem',
    }}>
      {error ? (
        <>
          <div style={{ fontSize: '2rem' }}>⚠️</div>
          <div style={{ color: '#ef4444', fontWeight: 700 }}>{error}</div>
          <a href="/anmelden" style={{ color: '#ffd700', fontSize: '0.9rem' }}>Zum Login →</a>
        </>
      ) : (
        <>
          <div style={{ fontSize: '2rem' }}>🔐</div>
          <div style={{ color: 'rgba(255,255,255,0.7)' }}>{status}</div>
        </>
      )}
    </div>
  );
}
